import { PublicProfileSlideContent } from "../../../domain/CMS/schema"
import { ProviderLicense } from "../../../domain/Provider/schema"
import { LicenseStatusEnum } from "../../shared/utils"

/**
 * Gets the display text for a license status, using CMS content if provided
 * @param license - The provider license object
 * @param publicProfileContent - CMS content for status strings (optional)
 * @returns The formatted status text
 */
export const getLicenseStatus = (
  license: ProviderLicense,
  publicProfileContent?: PublicProfileSlideContent, // Use correct type if available
): string => {
  switch (license?.licenseStatusDisplayId) {
    case LicenseStatusEnum.ACTIVE:
      return publicProfileContent?.statusActiveText ?? ""
    case LicenseStatusEnum.EXPIRED:
      return publicProfileContent?.statusExpiredText ?? ""
    case LicenseStatusEnum.EXPIRING_SOON:
      return publicProfileContent?.statusExpiringSoonText ?? ""
    default:
      return license?.licenseStatusDisplayId || ""
  }
}

/**
 * Checks if a license status should be displayed with warning styling
 * @param license - The provider license object
 * @returns True if the license status should be highlighted as a warning
 */
export const isLicenseStatusWarning = (license: ProviderLicense): boolean => {
  return (
    license?.licenseStatusDisplayId === LicenseStatusEnum.EXPIRING_SOON ||
    license?.licenseStatusDisplayId === LicenseStatusEnum.EXPIRED
  )
}
